
/**
 * Custom hook to manage product document links
 */
export const useProductDocuments = (productId: string) => {
  const getDocumentLink = () => {
    const productLinks: Record<string, string> = {
      "vpx-tc1-lt": "https://auroramultimedia.com/products/vpx-tc1-lt?section=download",
      "vpx-tc1-pro": "https://auroramultimedia.com/products/vpx-tc1-pro?section=download",
      "vpx-tc1-wp-2": "https://auroramultimedia.com/products/vpx-tc-1-wp-2?section=download",
      "vpx-uc1-ultra": "https://auroramultimedia.com/products/vpx-uc-1-ultra?section=download",
      "vpx-sdm-dp": "https://auroramultimedia.com/products/vpx-rx-1-sdm?section=download",
      
      "ipx-ts3a-cf-pro": "https://auroramultimedia.com/products/ipx-ts3a-cf-pro?section=download",
      "ipx-tx3a-wp-2-c": "https://auroramultimedia.com/products/ipx-tx-3-a-wp-2-c?section=download",
      "ipx-tc3a-wp3-pro": "https://auroramultimedia.com/products/ipx-tc3a-wp3-pro?section=download",
      "ipx-uc1-ultra": "https://auroramultimedia.com/products/ipx-uc1-ultra?section=download",
      
      "irc-bt1": "https://auroramultimedia.com/products/irc-bt-1?section=download",
      "bt-ac1": "https://auroramultimedia.com/products/bt-ac-1?section=download",
      "ipbaset-manager": "https://auroramultimedia.com/products/ipbaset-manager?section=download",
      
      "rxt-4-wm": "https://auroramultimedia.com/products/rxt-4?section=download",
      "rxt-8-wm": "https://auroramultimedia.com/products/rxt-8?section=download",
      "rxt-10-vs": "https://auroramultimedia.com/products/rxt-10-vs?section=download",
      "rxt-10d": "https://auroramultimedia.com/products/rxt-10d?section=download",
      "rxt-15-vs": "https://auroramultimedia.com/products/rxt-15-vs?section=download",
      "rxt-21-vs": "https://auroramultimedia.com/products/rxt-21-vs?section=download",
      
      "rxc-1-g2": "https://auroramultimedia.com/products/rxc-1-g2?section=download",
      "rxc-3-g2": "https://auroramultimedia.com/products/rxc-3-g2?section=download",
      "rxc-4-g2": "https://auroramultimedia.com/products/rxc-4-g2?section=download",
      
      "reax-core-studio": "https://auroramultimedia.com/products/reax-core-studio?section=download",
      
      "lxc-1": "https://auroramultimedia.com/products/lxc1?section=download",
      
      "dtx-44d": "https://auroramultimedia.com/products/dtx-44d?section=download",
      "dtx-88d": "https://auroramultimedia.com/products/dtx-88d?section=download",
      "dtx-1616d": "https://auroramultimedia.com/products/dtx-1616d?section=download",
      "dtx-3232d": "https://auroramultimedia.com/products/dtx-3232d?section=download",
      "dtx-6464d": "https://auroramultimedia.com/products/dtx-6464d?section=download",
      
      "dash": "https://auroramultimedia.com/products/dash?section=download",
      
      "dtx-amp-25-m": "https://auroramultimedia.com/products/dtx-amp-25-m?section=download",
      "skr-22t-xfr": "https://auroramultimedia.com/products/skr-22t-xfr?section=download",
      "rxt-4-d": "https://auroramultimedia.com/products/rxt-4-d?section=download",
      "rxt-4-dv": "https://auroramultimedia.com/products/rxt-4-dv?section=download",
      "bx-25d": "https://auroramultimedia.com/products/bx-25-d?section=download",
      
      "ibt-tc-1-bx": "https://auroramultimedia.com/products/ibt-tc-1-bx?section=download",
      "ibt-1-wp-1": "https://auroramultimedia.com/products/ibt-1-wp-1?section=download",
      
      "dxe-cat-s1-4k": "https://auroramultimedia.com/products/dxe-cat-s1-4k?section=download",
      "dxe-cat-s2-4k": "https://auroramultimedia.com/products/dxe-cat-s2-4k?section=download",
      "dxe-cat-tx1-4k": "https://auroramultimedia.com/products/dxe-cat-tx1-4k?section=download",
      "dxe-cat-tx2-4k": "https://auroramultimedia.com/products/dxe-cat-tx2-4k?section=download",
      "dxe-cat-rx1-4k": "https://auroramultimedia.com/products/dxe-cat-rx1-4k?section=download",
      "dxe-cat-rx2-4k": "https://auroramultimedia.com/products/dxe-cat-rx2-4k?section=download",
      "dxe-218": "https://auroramultimedia.com/products/dxe-218?section=download",
      "dxe-cat-rk3-2": "https://auroramultimedia.com/products/dxe-cat-rk3-2?section=download",
      "dxe-142a-ds": "https://auroramultimedia.com/products/dxe142ads?section=download",
      
      // Product links
      "DIDO-X4": "https://auroramultimedia.com/products/dido-x4?section=download",
      "CW-1": "https://auroramultimedia.com/products/cw-1?section=download"
    };
    
    return productLinks[productId];
  };

  return { getDocumentLink };
};
